<template>
  <div class="editGallery">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"></i>
        编辑广告
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="flush()">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="filtrate_head">
        <div class="filtrate_filer">编辑广告</div>
      </div>
      <div class="table">
        <el-form label-width="100px" style="padding-top:30px; margin: 0 auto">
          <el-form-item label="广告名称:">
            <el-input v-model="tower_name" :disabled="true"></el-input>
          </el-form-item>
          
          <el-form-item label="排序:">
            <el-input v-model="order_by"></el-input>
          </el-form-item>
          <el-form-item label="上/下线:">
            <template>
              <el-radio v-model="is_show" label="1">上线</el-radio>
              <el-radio v-model="is_show" label="0">下线</el-radio>
            </template>
          </el-form-item>
          <!-- <el-form-item label="广告样式:">
            <template>
              <el-radio v-model="style" label="1" @click="one()">一张广告图</el-radio>
              <el-radio v-model="style" :disabled="true" label="2" @click="two()">两张广告图</el-radio>
            </template>
            <div
              style="margin-bottom:-28px;font-size:14px;margin-top: 16px;color:rgba(153,234,153,1);"
            >一张广告图</div>
          </el-form-item> -->
          <el-form-item label="广告图片:">
            <div class="grid-content">
              <input
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="getImage1($event)"
              >
              <img
                v-show="shup"
                v-bind:src="serve+'/'+image"
                width="100px"
                height="300px"
              >
              <img v-show="shw1" v-bind:src="src1" width="100px" height="300px">
              <div class="notice">图片必须为jpg或png格式，且大小不能超过5mb</div>
              <div class="notice">推荐大小为:230X636px</div>
            </div>
          </el-form-item>

          <el-form-item label="广告链接:">
            <el-input v-model="link" placeholder="输入广告连接"></el-input>
            <div
              style="margin-bottom:-28px;margin-top: 16px;font-size:14px;color:rgba(153,234,153,1);"
            ></div>
            <!-- 两张广告图 -->
          </el-form-item>

          <!-- <el-form-item label="广告图片:" v-show="tow">
            <div class="grid-content">
              <input
                :disabled="true"
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="getImage2($event)"
              >
              <img
                v-show="shup1"
                v-bind:src="serve+'/'+img1"
                width="100px"
                height="100px"
              >
              <img v-show="shw2" v-bind:src="src2" width="100px" height="100px">
            </div>
          </el-form-item>

          <el-form-item label="广告图片:" v-show="tow">
            <div class="grid-content">
              <input
                :disabled="true"
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="getImage3($event)"
              >
              <img
                v-show="shup2"
                v-bind:src="serve+'/'+img2"
                width="100px"
                height="100px"
              >
              <img v-show="shw3" v-bind:src="src3" width="100px" height="100px">
              <div class="notice">图片必须为jpg或png格式，且大小不能超过5mb</div>
              <div class="notice">推荐大小为:230X306px</div>
            </div>
          </el-form-item>
          <el-form-item label="广告链接:">
            <el-input :disabled="true" placeholder="输入广告连接" v-model="link1"></el-input>
          </el-form-item>
          <el-form-item label="广告链接:">
            <el-input :disabled="true" placeholder="输入广告连接" v-model="link2"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button class="button" @click="submit()">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { serve: this.$store.state.serve,
      tow: true,
      order_by: "",
      show1: true,
      show2: true,
      show3: true,
      shw1: false,
      shw2: false,
      shw3: false,
      reader: new FileReader(),
      src1: null,
      src2: null,
      src3: null,
      image1: null,
      image2: null,
      image3: null,
      shup: false,
      shup1: false,
      shup2: false,
      gstyle: "1",
      username: "",
      token: "",
      id: this.$route.params.id,
      auth: "",
      class_id: "",
      image: "",
      img1: "",
      img2: "",
      is_show: "",
      link: "",
      link1: "",
      link2: "",
      order_by: "",
      style: "",
      tower_name: "",
      update_date: ""
    };
  },
  created() {
    this.$store.state.leftTitle = "楼层广告";
    this.$store.state.topActiveId = 7;
    this.flush();
  },
  methods: {
    one() {
      this.style = 1;
    },
    two() {
      this.style = 2;
    },
    //上传img
    getImage1(e) {
      this.shup = false;
      this.shw1 = true;
      this.image1 = event.target.files[0];
      var imgFile = event.target.files[0];
      this.reader.readAsDataURL(imgFile);
      var that = this;
      this.reader.onload = function() {
        that.src1 = that.reader.result;
      };
    },
    getImage2(e) {
      this.shup1 = false;
      this.shw2 = true;
      this.image2 = event.target.files[0];
      var imgFile = event.target.files[0];
      this.reader.readAsDataURL(imgFile);
      var that = this;
      this.reader.onload = function() {
        that.src2 = that.reader.result;
      };
    },
    getImage3(e) {
      this.shup2 = false;
      this.shw3 = true;
      this.image3 = event.target.files[0];
      var imgFile = event.target.files[0];
      this.reader.readAsDataURL(imgFile);
      var that = this;
      this.reader.onload = function() {
        that.src3 = that.reader.result;
      };
    },
    flush() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/admin/tower_ad_detail", {
          params: {
            username: this.username,
            token: this.token,
            id: this.id
          }
        })
        .then(res => {
          const json = res.data.data;
          if (res.data.status == "success") {
            that.tower_name = json.category;
            that.is_show = json.is_show;
            that.style = json.style;
            that.order_by = json.order_by;
            if (that.style === "1") {
              that.link = json.link;
              that.image = json.image;
              that.shup = true;
            } else if (that.style === "2") {
              var link1 = json.link.split(";");
              var img = json.image.split(";");
              that.shup1 = true;
              that.shup2 = true;
              for (var i = 0; i < img.length; i++) {
                that.img1 = img[0];
                that.img2 = img[1];
              }
              for (var i = 0; i < link1.length; i++) {
                //  that.propsData.push(link1[i]);
                that.link1 = link1[0];
                that.link2 = link1[1];
              }
            }
          }
        });
    },
    submit() {
      if (this.style === "1") {
        var that = this;
        this.username = this.$cookies.get("username");
        this.token = this.$cookies.get("token");
        const loading = this.$loading({
          lock: true,
          text: "正在上传",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        // if (this.link == "" || this.image1 == null) {
        //   this.$confirm("上传格式不正确", "提示", {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   });
        // }
        const formData = new FormData();
        formData.append("username", this.username);
        formData.append("token", this.token);
        formData.append("id", this.id);
        formData.append("tower_name", this.tower_name);
        formData.append("order_by", this.order_by);
        formData.append("style", this.style);
        formData.append("is_show", this.is_show);
        formData.append("link", this.link);
        formData.append("image", this.image1);
        this.axios
          .post(this.serve+"/admin/tower_AD", formData, config)
          .then(res => {
            if (res.data.status == "success") {
              that.$message({
                type:'success',
                message:"操作成功"
              })
              loading.close();
              that.$router.push({ path: "/admin/g_advertising" });
            }else if(res.data.code == '403'){
              loading.close();
              that.$message.error(res.data.msg); 
            } else if(res.data.status == 'error'){
              loading.close();
              that.$message.error('操作失败')
            }
          })
          // .catch(function(err) {
          //   alert("操作失败");
          // });
      }
      //  else {
      //   if ((this.shw3 && this.shw2) || (!this.shw3 && !this.shw2)) {
      //     var that = this;
      //     this.username = this.$cookies.get("username");
      //     this.token = this.$cookies.get("token");
      //     const loading = this.$loading({
      //       lock: true,
      //       text: "正在上传",
      //       spinner: "el-icon-loading",
      //       background: "rgba(0, 0, 0, 0.7)"
      //     });
      //     let config = {
      //       headers: {
      //         "Content-Type": "multipart/form-data"
      //       }
      //     };
      //     if (
      //       this.link1 == "" ||
      //       this.link2 == "" ||
      //       this.image2 == "" ||
      //       this.image3 == ""
      //     ) {
      //       this.$confirm("上传格式不正确", "提示", {
      //         confirmButtonText: "确定",
      //         cancelButtonText: "取消",
      //         type: "warning"
      //       });
      //     }
      //     const formData = new FormData();
      //     formData.append("username", this.username);
      //     formData.append("token", this.token);
      //     formData.append("id", this.id);
      //     formData.append("tower_name", this.tower_name);
      //     formData.append("order_by", this.order_by);
      //     formData.append("style", this.style);
      //     formData.append("is_show", this.is_show);
      //     formData.append("link1", this.link1);
      //     formData.append("link2", this.link2);
      //     formData.append("image1", this.image2);
      //     formData.append("image2", this.image3);
      //     this.axios
      //       .post(this.serve+"/admin/tower_AD2", formData, config)
      //       .then(res => {
            
      //         if (res.status === 200) {
      //           loading.close();
      //           that.$router.push({ path: "/admin/g_advertising" });
      //         }
      //       })
      //       .catch(function(err) {
      //         alert("操作失败");
      //       });
      //   } else {
      //     this.$confirm("修改图片时必须两张全部修改", "提示", {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning"
      //     });
      //   }
      // }
    }
  }
};
</script>
<style lang="scss">
.editGallery {
  #tetx {
    width: 330px;
    height: 200px;
  }
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .filtrate_head {
    width: 100%;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .filtrate_seek {
      position: relative;
      font-size: 16px;
      // border-bottom: 1px solid rgba(221, 221, 221, 1);
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 86px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      // margin: 24px 0 0 17px;
      display: flex;
      align-items: center;
      background: #fff;
      > strong {
        font-size: 16px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin-left: 24px;
        margin-right: 6px;
      }
      .filtrate_seek_sousuo {
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        position: absolute;
        right: 18px;
        top: 29px;
        cursor: pointer;
      }
      .filtrate_seek_sousuo:hover {
        color: #0099ff;
      }
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  textarea {
    height: 300px;
  }
  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
  }
  .table {
    background-color: #fff;
  }
  .row {
    margin-bottom: 20px;
  }
  .form {
    width: 450px;
    margin: 0 auto;
    padding: 20px 0;
    align-items: right;
  }
  .table {
    display: flex;
  }

  .label {
    line-height: 40px;
  }
  .button {
    width: 190px;
    height: 44px;
    background: rgba(0, 153, 255, 1);
    border-radius: 4px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
  .button:hover {
    background: rgba(46, 172, 255, 1);
  }

  .notice {
    font-size: 13px;
    color: #666;
  }
}
</style>
